// removed by extract-text-webpack-plugin
module.exports = {"buttonsWrapper":"gQ2ll"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/cn-skin-vg/styles/components/MastheadExtensionSubscriptionButtons.scss
 ** module id = 452
 ** module chunks = 0
 **/